var GlobalRichText = () => import('~/components/atoms/Editorial/Global/GlobalRichText.vue');
export default {
  name: 'SimpleParagraph',
  components: {
    GlobalRichText
  },
  props: {
    paragraph: {
      type: Array,
      required: true
    },
    hasReadMore: {
      type: Boolean,
      default: false
    },
    hasMargin: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hideText: this.hasReadMore
    };
  }
};